import React, { useEffect } from 'react';
import Table from '../../../components/common/table/Table';
import { BsFiletypeXml } from 'react-icons/bs';
import { FaTrash } from 'react-icons/fa';
import { SiMinutemailer } from 'react-icons/si';

import { usePaymentReminder } from '../../../context/paymentReminderContext/PaymentReminderContextProvider';
import { NavLink } from 'react-router-dom';

const PaymentReminderFileTable = () => {
  const {
    getPaymentReminderFilesAPI,
    response,
    totalElements,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
    unloadFile,
    setSingleFileData,
  } = usePaymentReminder();

  useEffect(() => {
    setSingleFileData(null);
    getPaymentReminderFilesAPI();
  }, [currentPage, pageSize, sortBy, sortDir]);

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field);
    setSortDir(direction);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const columns = [
    {
      header: 'File Name',
      render: (file) => (
        <div className="flex items-center gap-5">
          <div>
            <BsFiletypeXml />
          </div>
          <div>{file.fileName}</div>
        </div>
      ),
      field: 'fileName',
    },
    {
      header: 'Upload Date',
      field: 'loadDateTime',
      render: (file) => formatDate(file.loadDateTime),
    },
    { header: 'Total Customer', field: 'rowNos' },
    {
      header: 'Start Date',
      field: 'startDate',
      render: (file) => formatDate(file.startDate),
    },
    {
      header: 'End Date',
      field: 'endDate',
      render: (file) => formatDate(file.endDate),
    },
    { header: 'Reminder Status', field: 'reminderStatus' },
    {
      header: 'ACTIONS',
      render: (file) => (
        <div className="flex justify-start">
          <button
            className="mr-4 text-red-500"
            onClick={() => unloadFile(file.id)}
          >
            <FaTrash />
          </button>
          <NavLink
            to={`/set-reminder/fileInfo/${file.id}`}
            className="text-blue-500"
            state={{
              fileName: file.fileName,
              uploadDate: file.loadDateTime,
              totalCustomer: file.rowNos,
            }}
          >
            <SiMinutemailer />
          </NavLink>
        </div>
      ),
    },
  ];

  return (
    <div className="px-10">
      <div className="font-700 text-2xl">Uploaded Files</div>
      <Table
        columns={columns}
        data={response || []}
        totalElements={totalElements}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        onSortChange={handleSortChange}
        sortConfig={{ field: sortBy, direction: sortDir }}
      />
    </div>
  );
};

export default PaymentReminderFileTable;
